import axios from '@fs/zion-axios'
import { getUser, clearCachedUser } from '@fs/zion-user'
import cisAxiosConfig from '../cisAxiosConfig'
import throwCisError from './throwCisError'

const monthAbbrs = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export function toCisDate({ day, month, year }) {
  return `${day} ${monthAbbrs[+month - 1]} ${year}`
}

export default async function updateBirthDate(cisDate) {
  const { cisId } = await getUser()
  try {
    await axios.post(
      '/service/ident/cis/cis-public-api/v4/user',
      { users: [{ id: cisId, type: 'userAccount', birthDate: cisDate }] },
      cisAxiosConfig
    )
    clearCachedUser()
  } catch (error) {
    throwCisError(error)
  }
}
